var e={exports:{}};export{e as __module};
//# sourceMappingURL=jsx-runtime2.js.map
